import CityPageTemplate from "../city-template/CityPageTemplate";
import { newportNewsVaConfig } from "./data";

export default function NewportNewsVaPage() {
  return <CityPageTemplate config={newportNewsVaConfig} />;
}